exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#forgot-your-password-modal .modal-content .modal-body{padding:50px 50px 80px}#forgot-your-password-modal .text-input .tb{box-shadow:inset 0 1px 3px 0 rgba(101,116,134,.05);border:.5px solid #657486}", ""]);

